// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* FIX: Add media query for display height to set align-items to center on .modal */
@keyframes loadingGradient {
  0% {
    background-position: 0% 50%;
  }

  100% {
    background-position: -200% 0%;
  }
}

@keyframes zoom-in {
  0% {
    opacity: 0;
    transform: scale(0.7);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes zoom-out {
  0% {
    opacity: 1;
    transform: scale(1);
  }

  100% {
    opacity: 0;
    transform: scale(0.7);
  }
}
/*Desktop*/

.page-wrapper {
  display: flex;
  flex-direction: column;

  align-items: center;
  width: 100%;
}

ul a li {
  text-decoration: none;
}

.main-wrapper {
  padding: 25px 0px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.main-wrapper:before {
  content: "";
  left: 0;
  top: 0;
  display: block;
  position: absolute;
  background-image: url("https://i.pinimg.com/originals/e3/af/f8/e3aff803532ba650bfa072f6544dc33a.jpg");
  width: 100%;
  height: 100%;
  background-repeat: repeat-x repeat-y;
  background-position: 50% 0;
  opacity: 0.6;
  z-index: -1;
}

.main-wrapper-loader {
  margin: 100px 0px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 1024px;
}

/* .elements-wrapper {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
} */

.page-width {
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;
}

.single-page-content-wrapper {
  width: 80%;
  margin: 0 auto;
}

header {
  width: 100%;
}

h1 {
  height: 60px;
  width: 100%;
  margin: 10px;
  /* background: black; */
  color: white;
  align-self: center;
  padding-left: 7.5px;
  line-height: 60px;
  font-family: "Nunito", sans-serif;
}

h1:empty {
  height: inherit;
  width: inherit;
  background: #ccc;
  margin: 0;
  padding: 0;
  /* background-image: linear-gradient(grey, grey);
	background-size: 150px 35px;
	background-position: 10px;
	background-repeat: no-repeat; */
}

.loader {
  content: "";
  background-image: linear-gradient(to left, #ccc 0, #eee);
  position: absolute;
  height: inherit;
  width: inherit;
  left: 0;
  top: 0;
  background-position: 0 0;
  background-size: 200% 200%;
  background-repeat: no-repeat;
  animation: loadingGradient 0.3s linear infinite;
}

.loader-size-wrapper {
  width: 100px;
  height: 30px;
  position: absolute;
  margin: 15px 0;
}

.indent {
  /* top: 15px; */
  left: 10px;
}
.large {
  width: 225px;
}

.loader-bg {
  background: black;
  height: 60px;
  width: 100%;
  position: relative;
  align-self: center;
}

.loader-bg-95 {
  background: black;
  height: 60px;
  width: 95%;
  position: relative;
  align-self: center;
}

.loader-bg-none {
  height: 60px;
  width: 95%;
  position: relative;
  align-self: center;
}

.margin-top-15 {
  margin-top: 15px;
}

h2:empty {
  height: inherit;
  width: inherit;
  background: #ccc;
  margin: 0;
  padding: 0;
}

h3 {
  width: 95%;
  align-self: center;
}

h3:empty {
  height: inherit;
  width: inherit;
  background: #ccc;
  background-size: 10% 100%;
  background-position: 0px 0px;
  background-repeat: no-repeat;
  margin: 0;
  padding: 0;
}

footer {
  /* position: fixed; */
  background: black;
  /* height: 100px; */
  z-index: 1;
  width: 100%;
}

small {
  color: white;
  margin: 50px 0;
}

/* Modal  */
.modal {
  display: flex; /*Hidden by default*/
  position: fixed; /* Stay in place */
  z-index: 1001; /* Sit on top */
  /* padding-top: 100px; Location of the box */
  justify-content: center;
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}

/* Modal Content */
.modal-content {
  display: flex;
  flex-direction: column;
  background-color: #fefefe;
  margin: 0 auto;
  /* padding: 20px; */
  /* border: 1px solid #888; */
  height: fit-content;
  animation: zoom-in 0.3s 1;
}

/* The Close Button */
.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}

.thumb-nail__wrapper {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}

.thumbnail-matrix > section {
  background: white;
  padding: 15px;
  border: 1px solid black;
  border-radius: 5px;
  margin: 50px 0;
}

@media (max-width: 1224px) {
  .projects-section,
  .education__section,
  .about-me__section {
    padding: 50px 15px;
  }
}

/* Small Laptop */
/* @media (max-width: 1128px) {
  .projects-section,
  .education__section,
  .about-me__section {
    padding: 50px 15px;
  }
} */

/*Tablet*/

@media (max-width: 1115px) {
  .thumb-nail__wrapper {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 1024px) {
  .nav {
    /* width: 97%; */
  }

  .main-wrapper {
    width: 100%;
  }

  .main-wrapper-loader {
    width: 100%;
  }

  .h1 {
    width: 90%;
    align-self: center;
  }
  .projects-section,
  .education__section,
  .about-me__section,
  .tech-stack__section {
    padding: 50px 0;
  }
  .thumbnail-page-wrapper {
    margin: 5px;
  }
}
@media (max-width: 800px) {
  .thumb-nail__wrapper {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
}
/*Mobile*/

@media (max-width: 550px) {
  .thumb-nail__wrapper {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
  }

  .thumbnail-page-wrapper {
    max-width: 225px;
    justify-self: center;
  }
}

@media (max-width: 421px) {
  .main-wrapper {
    /* margin-top: 80px; */
    width: 100%;
  }

  .main-wrapper-loader {
    margin-top: 100px;
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/style-sheets/portfolio.css"],"names":[],"mappings":"AAAA,mFAAmF;AACnF;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,qBAAqB;EACvB;AACF;AACA,UAAU;;AAEV;EACE,aAAa;EACb,sBAAsB;;EAEtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,OAAO;EACP,MAAM;EACN,cAAc;EACd,kBAAkB;EAClB,qGAAqG;EACrG,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,0BAA0B;EAC1B,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;AACf;;AAEA;;;GAGG;;AAEH;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;;EAEnB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV;;;gCAG8B;AAChC;;AAEA;EACE,WAAW;EACX,wDAAwD;EACxD,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,OAAO;EACP,MAAM;EACN,wBAAwB;EACxB,0BAA0B;EAC1B,4BAA4B;EAC5B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;AACA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,4BAA4B;EAC5B,4BAA4B;EAC5B,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,aAAa,EAAE,oBAAoB;EACnC,eAAe,EAAE,kBAAkB;EACnC,aAAa,EAAE,eAAe;EAC9B,4CAA4C;EAC5C,uBAAuB;EACvB,OAAO;EACP,MAAM;EACN,WAAW,EAAE,eAAe;EAC5B,YAAY,EAAE,gBAAgB;EAC9B,cAAc,EAAE,4BAA4B;EAC5C,8BAA8B,EAAE,mBAAmB;EACnD,oCAAoC,EAAE,qBAAqB;AAC7D;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,4BAA4B;EAC5B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE;;;IAGE,kBAAkB;EACpB;AACF;;AAEA,iBAAiB;AACjB;;;;;;GAMG;;AAEH,SAAS;;AAET;EACE;IACE,aAAa;IACb,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;IACV,kBAAkB;EACpB;EACA;;;;IAIE,eAAe;EACjB;EACA;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,aAAa;IACb,qCAAqC;EACvC;AACF;AACA,SAAS;;AAET;EACE;IACE,aAAa;IACb,qCAAqC;EACvC;;EAEA;IACE,gBAAgB;IAChB,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;AACF","sourcesContent":["/* FIX: Add media query for display height to set align-items to center on .modal */\n@keyframes loadingGradient {\n  0% {\n    background-position: 0% 50%;\n  }\n\n  100% {\n    background-position: -200% 0%;\n  }\n}\n\n@keyframes zoom-in {\n  0% {\n    opacity: 0;\n    transform: scale(0.7);\n  }\n\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes zoom-out {\n  0% {\n    opacity: 1;\n    transform: scale(1);\n  }\n\n  100% {\n    opacity: 0;\n    transform: scale(0.7);\n  }\n}\n/*Desktop*/\n\n.page-wrapper {\n  display: flex;\n  flex-direction: column;\n\n  align-items: center;\n  width: 100%;\n}\n\nul a li {\n  text-decoration: none;\n}\n\n.main-wrapper {\n  padding: 25px 0px;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.main-wrapper:before {\n  content: \"\";\n  left: 0;\n  top: 0;\n  display: block;\n  position: absolute;\n  background-image: url(\"https://i.pinimg.com/originals/e3/af/f8/e3aff803532ba650bfa072f6544dc33a.jpg\");\n  width: 100%;\n  height: 100%;\n  background-repeat: repeat-x repeat-y;\n  background-position: 50% 0;\n  opacity: 0.6;\n  z-index: -1;\n}\n\n.main-wrapper-loader {\n  margin: 100px 0px;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: 1024px;\n}\n\n/* .elements-wrapper {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n} */\n\n.page-width {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  width: 100%;\n}\n\n.single-page-content-wrapper {\n  width: 80%;\n  margin: 0 auto;\n}\n\nheader {\n  width: 100%;\n}\n\nh1 {\n  height: 60px;\n  width: 100%;\n  margin: 10px;\n  /* background: black; */\n  color: white;\n  align-self: center;\n  padding-left: 7.5px;\n  line-height: 60px;\n  font-family: \"Nunito\", sans-serif;\n}\n\nh1:empty {\n  height: inherit;\n  width: inherit;\n  background: #ccc;\n  margin: 0;\n  padding: 0;\n  /* background-image: linear-gradient(grey, grey);\n\tbackground-size: 150px 35px;\n\tbackground-position: 10px;\n\tbackground-repeat: no-repeat; */\n}\n\n.loader {\n  content: \"\";\n  background-image: linear-gradient(to left, #ccc 0, #eee);\n  position: absolute;\n  height: inherit;\n  width: inherit;\n  left: 0;\n  top: 0;\n  background-position: 0 0;\n  background-size: 200% 200%;\n  background-repeat: no-repeat;\n  animation: loadingGradient 0.3s linear infinite;\n}\n\n.loader-size-wrapper {\n  width: 100px;\n  height: 30px;\n  position: absolute;\n  margin: 15px 0;\n}\n\n.indent {\n  /* top: 15px; */\n  left: 10px;\n}\n.large {\n  width: 225px;\n}\n\n.loader-bg {\n  background: black;\n  height: 60px;\n  width: 100%;\n  position: relative;\n  align-self: center;\n}\n\n.loader-bg-95 {\n  background: black;\n  height: 60px;\n  width: 95%;\n  position: relative;\n  align-self: center;\n}\n\n.loader-bg-none {\n  height: 60px;\n  width: 95%;\n  position: relative;\n  align-self: center;\n}\n\n.margin-top-15 {\n  margin-top: 15px;\n}\n\nh2:empty {\n  height: inherit;\n  width: inherit;\n  background: #ccc;\n  margin: 0;\n  padding: 0;\n}\n\nh3 {\n  width: 95%;\n  align-self: center;\n}\n\nh3:empty {\n  height: inherit;\n  width: inherit;\n  background: #ccc;\n  background-size: 10% 100%;\n  background-position: 0px 0px;\n  background-repeat: no-repeat;\n  margin: 0;\n  padding: 0;\n}\n\nfooter {\n  /* position: fixed; */\n  background: black;\n  /* height: 100px; */\n  z-index: 1;\n  width: 100%;\n}\n\nsmall {\n  color: white;\n  margin: 50px 0;\n}\n\n/* Modal  */\n.modal {\n  display: flex; /*Hidden by default*/\n  position: fixed; /* Stay in place */\n  z-index: 1001; /* Sit on top */\n  /* padding-top: 100px; Location of the box */\n  justify-content: center;\n  left: 0;\n  top: 0;\n  width: 100%; /* Full width */\n  height: 100%; /* Full height */\n  overflow: auto; /* Enable scroll if needed */\n  background-color: rgb(0, 0, 0); /* Fallback color */\n  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */\n}\n\n/* Modal Content */\n.modal-content {\n  display: flex;\n  flex-direction: column;\n  background-color: #fefefe;\n  margin: 0 auto;\n  /* padding: 20px; */\n  /* border: 1px solid #888; */\n  height: fit-content;\n  animation: zoom-in 0.3s 1;\n}\n\n/* The Close Button */\n.close {\n  color: #aaaaaa;\n  float: right;\n  font-size: 28px;\n  font-weight: bold;\n}\n\n.close:hover,\n.close:focus {\n  color: #000;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.thumb-nail__wrapper {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n}\n\n.thumbnail-matrix > section {\n  background: white;\n  padding: 15px;\n  border: 1px solid black;\n  border-radius: 5px;\n  margin: 50px 0;\n}\n\n@media (max-width: 1224px) {\n  .projects-section,\n  .education__section,\n  .about-me__section {\n    padding: 50px 15px;\n  }\n}\n\n/* Small Laptop */\n/* @media (max-width: 1128px) {\n  .projects-section,\n  .education__section,\n  .about-me__section {\n    padding: 50px 15px;\n  }\n} */\n\n/*Tablet*/\n\n@media (max-width: 1115px) {\n  .thumb-nail__wrapper {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (max-width: 1024px) {\n  .nav {\n    /* width: 97%; */\n  }\n\n  .main-wrapper {\n    width: 100%;\n  }\n\n  .main-wrapper-loader {\n    width: 100%;\n  }\n\n  .h1 {\n    width: 90%;\n    align-self: center;\n  }\n  .projects-section,\n  .education__section,\n  .about-me__section,\n  .tech-stack__section {\n    padding: 50px 0;\n  }\n  .thumbnail-page-wrapper {\n    margin: 5px;\n  }\n}\n@media (max-width: 800px) {\n  .thumb-nail__wrapper {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n/*Mobile*/\n\n@media (max-width: 550px) {\n  .thumb-nail__wrapper {\n    display: grid;\n    grid-template-columns: repeat(1, 1fr);\n  }\n\n  .thumbnail-page-wrapper {\n    max-width: 225px;\n    justify-self: center;\n  }\n}\n\n@media (max-width: 421px) {\n  .main-wrapper {\n    /* margin-top: 80px; */\n    width: 100%;\n  }\n\n  .main-wrapper-loader {\n    margin-top: 100px;\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
